<div class="payee-radio-group-wrapper">
  <ng-content select="payee-radio-button"></ng-content>
</div>